"use strict";
var React = require("react");
var MessagesStore = require("../../stores/MessagesStore");
var MessagesActions = require("../../actions/MessagesActions");

var MessageItem = React.createClass({
    render: function() {
        return (
            <tr>
                <td>{this.props.sender}</td>
                <td>{this.props.title}</td>
                <td>{this.props.date}</td>
            </tr>
        );
    }
});

function getMessagesState() {
    MessagesActions.fetchMessages();
    return {
        messages: MessagesStore.getState().messages
    };
}

var Messages = React.createClass({
    getInitialState: function() {
        return getMessagesState();
    },

    fetchMessages: function() {
        MessagesActions.fetchMessages();
    },

    render: function() {
        var listOfMessages = [];
        var messages = this.state.messages;

        for (var i = 0; i < messages.length; i++) {
            listOfMessages.push(<MessageItem key={messages[i].id} sender={messages[i].sender} title={messages[i].title} date={messages[i].date} />);
        }

                        // {listOfMessages}
        return (
            <div className = "content_section">
                <div className="container">
                    <table className="table table-hover messages">
                        <h1>Coming soon...</h1>
                    </table>
                </div>
            </div>
        );
    }
});

module.exports = Messages;



// WEBPACK FOOTER //
// ./app/scripts/ui/Messages/Messages.react.js